export const GET_OCCUPATION_LIST = "GET_OCCUPATION_LIST";
export const OCCUPATION_PROCESSING = "OCCUPATION_PROCESSING";
export const STOP_OCCUPATION_PROCESSING = "STOP_OCCUPATION_PROCESSING";
